// Format images on blog posts

if (window.location.href.includes("blogs")) {
  const articleLinks = document.querySelectorAll(
    ".article-template__content a"
  );
  if (articleLinks.length > 0) {
    articleLinks.forEach((link) => {
      if (link.querySelector("img")) {
        const parent = link.parentNode;
        parent?.classList.add("article-template__content--image");
      }
    });
  }
}


// Anchor navigation behavior
var anchorLinks = document.querySelectorAll('.anchor-link');
var stickyHeader = document.querySelector('sticky-header'); 
var anchorNavigation = document.querySelector('.anchor-navigation');
var annocementSlider = document.querySelector('announcement-slider');

// Hero slider buttons
var heroSliderButtons = document.querySelectorAll('hero-slider .button-group .button'); 

var headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
var anchorNavigationHeight = anchorNavigation ? anchorNavigation.offsetHeight : 0;
var annocementSliderHeight = annocementSlider ? annocementSlider.offsetHeight : 0;

anchorLinks.forEach(function(link) {
    link.addEventListener('click', scrollFunction);
});

heroSliderButtons.forEach(function(button) {
    button.addEventListener('click', scrollFunction);
});

function scrollFunction(e) {
  var targetId = this.getAttribute('href');
  
  // Check if href is an internal page anchor
  if (targetId.startsWith('#')) {
      e.preventDefault();

      var targetElement = document.querySelector(targetId);
      if (targetElement) {
          var targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight - anchorNavigationHeight - annocementSliderHeight;
          window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
          });
      }
  } 
}


const sizeGuideTrigger = document.querySelector(".size-guide-trigger");
const sizeGuideClose = document.querySelector(".size-guide-close");
const body = document.body;

if (sizeGuideTrigger) {
  sizeGuideTrigger.addEventListener("click", function() {
    body.classList.add("body-no-scroll");
  });
}

if (sizeGuideClose) {
  sizeGuideClose.addEventListener("click", function() {
    body.classList.remove("body-no-scroll");
  });
}

const guideMenuTrigger = document.querySelector(".guide_menu-title[drawer-trigger]");
const guideMenuDrawer = document.querySelector(".guide_menu-mobile-drawer");
const guideMenuClose = document.querySelector(".guide_menu-mobile-drawer-close");
const guideMenu = document.querySelector(".guide_menu-navigation");
const guideMenuMobile = document.querySelector(".guide_menu-mobile-drawer");
const guideMenuOpenItem = guideMenu?.querySelector("details.child-active");
const guideMenuOpenItemMobile = guideMenuMobile?.querySelector("details.child-active");

if (guideMenuTrigger) {
  guideMenuTrigger.addEventListener("click", () => {
    guideMenuDrawer.classList.add("active");
  });
}

if (guideMenuClose) {
  guideMenuClose.addEventListener("click", () => {
    guideMenuDrawer.classList.remove("active");
  });
}

if (guideMenuOpenItem) {
  guideMenuOpenItem.setAttribute("open", "");
  guideMenuOpenItem.querySelector("summary").setAttribute("aria-expanded", "true");
}

if (guideMenuOpenItemMobile) {
  guideMenuOpenItemMobile.setAttribute("open", "");
  guideMenuOpenItemMobile.querySelector("summary").setAttribute("aria-expanded", "true");
}